import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  CollectionDatesDto,
  CollectionDateDto,
  CollectionDatesModel,
  CollectionDateModel,
  GetCollectionDatesResp,
} from '../types/collection-dates'

export const transformCollectionDate = (
  collectionDate: CollectionDateDto,
): CollectionDateModel => ({
  collection: collectionDate.collection,
  collectionTo: collectionDate.collection_to,
  dropOffTo: collectionDate.drop_off_to,
})

export const transformCollectionDates = (
  collectionDates: CollectionDatesDto,
): CollectionDatesModel => ({
  dropOffType: collectionDates.drop_off_type,
  dates: collectionDates.dates.map(transformCollectionDate),
  shipmentDeadline: collectionDates.shipment_deadline,
})

export const transformCollectionDatesResponse = (response: Response<GetCollectionDatesResp>) =>
  transformCollectionDates(response.collection_dates)
